import { LightShowOperation } from './lightshow-operation';
import { LightshowState } from '../lightshow-state';
import { FlashTypes } from '../operation-types';

export class ImageFadeoutOperation extends LightShowOperation {

  constructor(position: number, duration: number) {
    super();
    this.position = position;
    this.duration = duration;
  }

  public toJson(): any[] {
    return [
      { type: FlashTypes.imageFadeOut, duration: Math.round(this.duration) / 1000, time: Math.round(this.position) }, // preload image
    ];
  }

  public end(state: LightshowState) {
    state.imageOpacity = 0;
    state.imageUrl = null;
  }
  public tick(state: LightshowState) {
    state.imageOpacity = 1 - (state.playbackPosition - this.position) / this.duration;
  }
  public wait () {}
}
